// Wrapper Collapse com label = Tag colorido. Usado pra listar registros
// de divergência (apenas-CA, apenas-XLSX, divergentes) na reconciliação.
import { Collapse, Tag } from 'antd';

interface Props {
  titulo: string;
  cor: string;
  children: any;
}

export default function DetalheLista({ titulo, cor, children }: Props) {
  return (
    <Collapse
      size="small" style={{ marginTop: 8, background: '#FAFBFF' }} ghost
      items={[{ key: 'd', label: <Tag color={cor}>{titulo}</Tag>, children }]}
    />
  );
}
